module.exports = __webpack_public_path__ + "static/media/pivot.b32eb474.png";